import { useApiStore } from '@/stores/apiStore';
import { InboxMessageApi } from '@/../generated-client/apis/InboxMessageApi';
import { InboxMessageOnAzure } from '../../generated-client/models';

let inboxMessageApi: InboxMessageApi | null = null;
let lastConfig: unknown = null;

function getInboxMessageApi(): InboxMessageApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (inboxMessageApi === null || lastConfig !== apiConfig) {
    inboxMessageApi = new InboxMessageApi(apiConfig);
    lastConfig = apiConfig;
  }

  return inboxMessageApi;
}

export const getAllInboxMessages = async (): Promise<InboxMessageOnAzure[]> => {
  const api = getInboxMessageApi();
  return await api.apiInboxMessageGetAllGet();
};

export const updateSafeguardMessage = async (message: InboxMessageOnAzure) => {
  const api = getInboxMessageApi();
  return await api.apiInboxMessageUpdatePut({ inboxMessageUpdate: message });
};

export const deleteInboxMessage = async (message: InboxMessageOnAzure) => {
  const api = getInboxMessageApi();
  return await api.apiInboxMessageDeleteDelete({
    inboxMessageDelete: { id: message.id },
  });
};

export const addInboxMessage = async (
  message: InboxMessageOnAzure,
): Promise<InboxMessageOnAzure> => {
  const api = getInboxMessageApi();
  return (await api.apiInboxMessageAddPost({
    inboxMessageCreate: message,
  })) as unknown as InboxMessageOnAzure;
};
